(function () {
  class LoanV2 extends Loan {
    configure() {
      super.configure();
      this.ui.form = "#formNewLoan";
      this.ui.continueBtn = ".js-loan-v2-continue";
      this.ui.waitingModal = "#loan-approval-waiting-modal";
      this.pollIntervalMs = 10000;
      this.pollTimer = null;
      this.approvalContext = null;
    }

    loadComponents() {
      this.configure();
      this.needFormValidation();
      this.textUpperCase();
      this.loadSelect2();
      this.onlyLetter();
      this.onlyNumber();
      this.togglePepFields();
      this.toggleEmployeeFields();
      this.bindProfessionHelpModal();
      this.bindIllicitActivities();
      this.bindLoanFlowFileInputs();
      this.bindContinue();
      this.bindWaitingModalActions();
    }

    bindLoanFlowFileInputs() {
      const operation = this;

      $(document)
        .off("click.loanFlowFile", ".js-loan-flow-file-trigger")
        .on("click.loanFlowFile", ".js-loan-flow-file-trigger", function (e) {
          e.preventDefault();
          $(this).closest("[data-loan-flow-file]").find(".js-loan-flow-file-input").trigger("click");
        });

      $(document)
        .off("change.loanFlowFile", ".js-loan-flow-file-input")
        .on("change.loanFlowFile", ".js-loan-flow-file-input", function () {
          const input = this;
          const file = input.files && input.files[0];
          const $wrap = $(input).closest("[data-loan-flow-file]");
          const $name = $wrap.find(".js-loan-flow-file-name");

          if (file && !operation.loanFlowFileMatchesAccept(file, input.accept)) {
            operation.showLoanFlowFileTypeError($wrap, file);
            input.value = "";
            return;
          }

          operation.clearLoanFlowFileTypeError($wrap);

          if (file) {
            $name.text(file.name).addClass("loan-flow-v2__file-name--selected");
            operation.updateLoanFlowFilePreview($wrap, file);
          } else if ($wrap.attr("data-existing-file") === "true") {
            $name
              .text($wrap.attr("data-original-name") || "Seleccione el archivo")
              .addClass("loan-flow-v2__file-name--selected");
          } else {
            $name.text("Seleccione el archivo").removeClass("loan-flow-v2__file-name--selected");
            $wrap.find(".js-loan-flow-file-preview").remove();
          }
        });
    }

    loanFlowFileExtension(file) {
      const name = (file && file.name) || "";
      const ext = name.includes(".") ? name.split(".").pop() : "";
      return ext ? `.${ext.toLowerCase()}` : (file && file.type) || "";
    }

    loanFlowFileMatchesAccept(file, accept) {
      if (!file || !accept) return true;

      const tokens = String(accept)
        .split(",")
        .map((token) => token.trim().toLowerCase())
        .filter(Boolean);
      if (!tokens.length) return true;

      const name = (file.name || "").toLowerCase();
      const ext = name.includes(".") ? name.split(".").pop() : "";
      const mime = (file.type || "").toLowerCase();
      const imageExts = ["jpg", "jpeg", "png", "gif"];

      return tokens.some((token) => {
        if (token === "image/*") {
          return imageExts.includes(ext) || ["image/jpeg", "image/jpg", "image/png", "image/gif"].includes(mime);
        }
        if (token === "application/pdf") {
          return ext === "pdf" || mime === "application/pdf";
        }
        if (token.startsWith(".")) {
          return ext === token.slice(1);
        }
        if (token.includes("/")) {
          return mime === token;
        }
        return ext === token;
      });
    }

    showLoanFlowFileTypeError($wrap, file) {
      const extension = this.loanFlowFileExtension(file) || "este tipo";
      const types = $wrap.attr("data-allowed-types") || "";
      const template =
        $wrap.attr("data-invalid-file-message") ||
        i18n.t("loans.step_three.invalid_file_type", { extension, types });
      const message = String(template)
        .replace(/%\{extension\}/g, extension)
        .replace(/%\{types\}/g, types);

      $wrap.addClass("is-invalid");
      $wrap
        .find(".js-loan-flow-file-error")
        .text(message)
        .prop("hidden", false);
      $wrap
        .find(".js-loan-flow-file-name")
        .text("Seleccione el archivo")
        .removeClass("loan-flow-v2__file-name--selected");
      $wrap.find(".js-loan-flow-file-preview").remove();
    }

    clearLoanFlowFileTypeError($wrap) {
      $wrap.removeClass("is-invalid");
      $wrap.find(".js-loan-flow-file-error").text("").prop("hidden", true);
    }

    updateLoanFlowFilePreview($wrap, file) {
      let $preview = $wrap.children(".js-loan-flow-file-preview");
      if (!$preview.length) {
        $preview = $('<div class="loan-flow-v2__file-preview js-loan-flow-file-preview"></div>');
        $wrap.append($preview);
      }
      $preview.empty();
      if (!file) return;

      const objectUrl = URL.createObjectURL(file);
      const isPdf = file.type === "application/pdf" || /\.pdf$/i.test(file.name);
      const isImage =
        /^image\//.test(file.type) || /\.(jpe?g|png|gif|webp)$/i.test(file.name);

      if (isImage) {
        const $link = $("<a>", {
          href: objectUrl,
          target: "_blank",
          rel: "noopener",
          class: "loan-flow-v2__file-preview-link",
        });
        $link.append(
          $("<img>", {
            src: objectUrl,
            alt: file.name,
            class: "loan-flow-v2__file-preview-img",
          }),
        );
        $preview.append($link);
        $preview.append(
          $("<a>", {
            href: objectUrl,
            target: "_blank",
            rel: "noopener",
            class: "loan-flow-v2__file-preview-doc",
            text: "Ver imagen",
          }),
        );
      } else {
        $preview.append(
          $("<a>", {
            href: objectUrl,
            target: "_blank",
            rel: "noopener",
            class: "loan-flow-v2__file-preview-doc",
            text: isPdf ? "Ver PDF" : "Ver archivo",
          }),
        );
        if (isPdf) {
          $preview.append(
            $("<iframe>", {
              src: objectUrl,
              class: "loan-flow-v2__file-preview-pdf",
              title: "Vista previa PDF",
            }),
          );
        }
      }
    }

    bindIllicitActivities() {
      const $select = $(".js-illicit-activities");
      const $explanation = $(".js-illicit-explanation");
      if (!$select.length) return;

      let confirmedYes = String($select.val()) === "true";
      let confirming = false;
      let rejecting = false;

      const sync = () => {
        const show = String($select.val()) === "true";
        $explanation.toggleClass("d-none", !show);
        if (!show) {
          $explanation.find("textarea").val("");
          confirmedYes = false;
        }
      };

      const revertToNo = () => {
        confirmedYes = false;
        confirming = true;
        $select.val("false");
        if ($select.hasClass("select2-hidden-accessible")) {
          $select.trigger("change.select2");
        }
        confirming = false;
        sync();
      };

      const rejectNow = () => {
        const rejectUrl = $select.data("reject-url");
        if (!rejectUrl) {
          confirmedYes = true;
          sync();
          return;
        }
        if (rejecting) return;
        rejecting = true;

        const csrf =
          document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";
        const explanation = $explanation.find("textarea").val() || "";
        const body = new URLSearchParams();
        body.set("illicit_activities_explanation", explanation);

        fetch(rejectUrl, {
          method: "PATCH",
          headers: {
            "X-CSRF-Token": csrf,
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
          body: body.toString(),
          credentials: "same-origin",
        })
          .then(async (response) => {
            const data = await response.json().catch(() => ({}));
            if (!response.ok) {
              throw new Error(data.error || "No se pudo rechazar el préstamo.");
            }
            window.location.href = data.redirect_url || "/loans";
          })
          .catch((err) => {
            rejecting = false;
            revertToNo();
            bootbox.alert(err.message || "No se pudo rechazar el préstamo.");
          });
      };

      $select.off("change.loanV2Illicit").on("change.loanV2Illicit", function () {
        if (confirming || rejecting) return;

        const yes = String($select.val()) === "true";
        if (!yes) {
          sync();
          return;
        }
        if (confirmedYes) {
          sync();
          return;
        }

        const message =
          $select.data("confirm-message") ||
          "¿Está seguro de que el cliente ha sido investigado por blanqueo de capitales? Si confirma, el préstamo será rechazado de inmediato.";

        bootbox.confirm({
          message: message,
          buttons: {
            confirm: { label: "Sí, confirmar", className: "btn-danger" },
            cancel: { label: "No", className: "btn-secondary" },
          },
          callback: function (result) {
            if (result) {
              confirmedYes = true;
              sync();
              rejectNow();
            } else {
              revertToNo();
            }
          },
        });
      });

      sync();
    }

    bindWaitingModalActions() {
      const operation = this;
      const $modal = $(operation.ui.waitingModal);

      $modal
        .find(".js-loan-approval-next")
        .off("click.loanV2Next")
        .on("click.loanV2Next", function () {
          if ($(this).prop("disabled")) return;
          const ctx = operation.approvalContext || {};
          const nextUrl = ctx.next_url || ctx.device_url;
          const loanId = ctx.loan_id;
          const stage = ctx.stage;

          if (nextUrl) {
            window.location.href = nextUrl;
          } else if (loanId && stage === "kyc" && window.Routes && typeof Routes.summary_v2_loan_path === "function") {
            window.location.href = Routes.summary_v2_loan_path(loanId);
          } else if (loanId && window.Routes && typeof Routes.device_v2_loan_path === "function") {
            window.location.href = Routes.device_v2_loan_path(loanId);
          } else if (loanId && stage === "kyc") {
            window.location.href = "/v2/loans/" + loanId + "/summary";
          } else if (loanId) {
            window.location.href = "/v2/loans/" + loanId + "/device";
          }
        });
    }

    loadDeviceFlowComponents() {
      this.configure();
      this.ui.form = "#formNewLoan";

      $("input[name*='[percentage_compost_id]']").first().prop("checked", true);
      if (!$("input[name*='[payment_period_id]']:checked").length) {
        $("input[name*='[payment_period_id]']").first().prop("checked", true);
      }

      this.needFormValidation();
      this.loadSelect2();
      this.loadSelect2Cascade(
        "#device_brand_id",
        "#loan_details_phone_loan_attributes_device_model_id"
      );
      this.loadBrandsMaxPrice();
      this.onlyNumber();
      this.maskedNumber();
      this.calculateSum();
      this.addValidatorDevicePrice();
      this.bindDeviceSubmitGuard();
      this.stylePlanSelections();
      this.refreshLetterPreview();
    }

    loadCustomerDataComponents(formSelector) {
      this.configure();
      this.ui.form = formSelector || "#formCustomerDataV2";
      this.needFormValidation();
      if (this.ui.form !== "#publicLoanApplication") {
        this.loadSelect2();
        this.loadSelect2Cascade(
          "#loan_customer_detail_attributes_province_id",
          "#loan_customer_detail_attributes_district_id"
        );
        this.loadSelect2Cascade(
          "#loan_customer_detail_attributes_district_id",
          "#loan_customer_detail_attributes_jurisdiction_id"
        );
      }
      this.onlyLetter();
      this.onlyNumber();
      this.togglePepFields();
      this.toggleEmployeeFields();
      this.toggleFinalBeneficiaryFields();
      this.bindIllicitActivities();
      this.bindLoanFlowFileInputs();
      this.bindKycConsents();
      this.bindTransactionalPaymentRequired();
      this.bindProfessionHelpModal();
      this.bindKycPhoneValidations();
    }

    bindTransactionalPaymentRequired() {
      const $select = $(".js-transactional-payment-method");
      if (!$select.length) return;

      const markInvalid = () => {
        $select.addClass("is-invalid");
        $select.closest("div").find("span.select2-selection").addClass("is-invalid");
        $select[0].scrollIntoView({ behavior: "smooth", block: "center" });
      };

      const clearInvalid = () => {
        $select.removeClass("is-invalid");
        $select.closest("div").find("span.select2-selection").removeClass("is-invalid");
      };

      $select.off("change.txnPayment").on("change.txnPayment", function () {
        if ($(this).val()) clearInvalid();
      });

      $select.closest("form")
        .off("submit.txnPayment")
        .on("submit.txnPayment", function (e) {
          if ($select.val()) return;
          e.preventDefault();
          markInvalid();
          return false;
        });
    }

    bindKycConsents() {
      const sync = () => {
        const $consents = $(".js-kyc-consent");
        if (!$consents.length) return;
        const allChecked = $consents.toArray().every((el) => el.checked);
        $(".js-kyc-continue").prop("disabled", !allChecked);
      };

      $(document)
        .off("change.loanV2KycConsents", ".js-kyc-consent")
        .on("change.loanV2KycConsents", ".js-kyc-consent", sync);

      $("#formCustomerDataV2")
        .off("submit.loanV2KycConsents")
        .on("submit.loanV2KycConsents", function (e) {
          const $consents = $(".js-kyc-consent");
          if ($consents.length && !$consents.toArray().every((el) => el.checked)) {
            e.preventDefault();
            alert("Debe aceptar todas las confirmaciones para continuar.");
            return false;
          }
        });

      sync();
    }

    refreshLetterPreview() {
      const operation = this;
      const loanAmount = operation.calculateLoanAmount();
      $(operation.ui.result).val(loanAmount);
      $(operation.ui.loanAmount).val(loanAmount);

      const priceWithoutItbms = operation.calculateDevicePriceWithoutITBMS();
      $(operation.ui.jsDevicePriceITBMS).text(
        typeof priceWithoutItbms.format === "function"
          ? priceWithoutItbms.format()
          : Number(priceWithoutItbms || 0).toFixed(2)
      );

      if (typeof operation.calculateInitialCompost === "function") {
        operation.calculateInitialCompost();
      }

      operation.calculateLetterPreview();
      operation.formatLetterPreviewUsd();
    }

    bindDeviceConsents() {
      // Consents moved to step 3 (customer data). No-op for device step.
    }

    setStepperStep(step) {
      const $steps = $(".loan-flow-v2__stepper-step");
      if (!$steps.length) return;
      $steps.each(function (index) {
        $(this).toggleClass("loan-flow-v2__stepper-step--active", index + 1 <= step);
      });
    }

    stylePlanSelections() {
      const operation = this;
      const syncPlan = () => {
        $(".loan-flow-v2__plan-card").removeClass("loan-flow-v2__plan-card--active");
        $("input[name*='[percentage_compost_id]']:checked")
          .closest(".loan-flow-v2__plan-card")
          .addClass("loan-flow-v2__plan-card--active");
      };
      const syncTerm = () => {
        $(".loan-flow-v2__term-pill").removeClass("loan-flow-v2__term-pill--active");
        $("input[name*='[payment_period_id]']:checked")
          .closest(".loan-flow-v2__term-pill")
          .addClass("loan-flow-v2__term-pill--active");
      };

      $(document)
        .off("change.loanV2Plan", "input[name*='[percentage_compost_id]']")
        .on("change.loanV2Plan", "input[name*='[percentage_compost_id]']", function () {
          syncPlan();
          operation.refreshLetterPreview();
        });
      $(document)
        .off("change.loanV2Term", "input[name*='[payment_period_id]']")
        .on("change.loanV2Term", "input[name*='[payment_period_id]']", function () {
          syncTerm();
          operation.refreshLetterPreview();
        });

      $(operation.ui.devicePrice)
        .off("blur.loanV2LetterUsd input.loanV2LetterUsd")
        .on("blur.loanV2LetterUsd change.loanV2LetterUsd", function () {
          operation.refreshLetterPreview();
        });

      syncPlan();
      syncTerm();
    }

    formatLetterPreviewUsd() {
      const raw = String($(this.ui.letterPreview).val() || "0.00").replace(/[^\d.]/g, "");
      const amount = Number(raw || 0).toFixed(2);
      $(this.ui.letterPreview).val("$" + amount + " USD");
    }

    calculateInitialCompost() {
      const price = this.calculateDevicePrice();
      const percentage = Number($(this.ui.percentageCompost).data("value")) || 0;
      const initial = Number((price * (percentage / 100)).toFixed(2));
      const formatted =
        typeof initial.format === "function" ? initial.format() : initial.toFixed(2);
      $(this.ui.jsInitialCompostPreview).text("$" + formatted);
    }

    calculateAge() {
      const birthDate = $(this.ui.customerBirthDate).val();
      if (!birthDate) return 0;
      return parseInt(this.currentAge(birthDate), 10) || 0;
    }

    getInterest() {
      const operation = this;
      const age = operation.calculateAge();
      const $gender = $(operation.ui.customerGender);
      const gender = $gender.is("select")
        ? $gender.find("option:selected").val()
        : $gender.val();
      const paymentPeriod = operation.getPaymentPeriod();
      const percentageCompostID = Number($(operation.ui.percentageCompost).val());
      const rates = $(operation.ui.jsRootWeb).data("interest-rate") || {};

      if (
        typeof rates[paymentPeriod] === "undefined" ||
        typeof rates[paymentPeriod][percentageCompostID] === "undefined"
      ) {
        return 0;
      }

      const interest = rates[paymentPeriod][percentageCompostID];
      const maxAge = (gon && gon.global && gon.global.max_age && gon.global.max_age.retired) || {};

      if (
        (gender === "female" && age >= maxAge.female) ||
        (gender === "male" && age >= maxAge.male)
      ) {
        return (interest - interest * 0.15) / 12 / 100;
      }

      return interest / 12 / 100;
    }

    fillSummaryPanel() {
      const operation = this;
      var paymentTypeKey = $(operation.ui.paymentType).val() || "biweekly";
      if (["es_pan", "es_pan_lsg"].includes(document.documentElement.lang)) {
        paymentTypeKey = "biweekly";
      }
      var payment_type = i18n.t("activerecord.enums.loan.payment_types." + paymentTypeKey);
      var period_quantity = operation.getPaymentPeriod();
      var frecuency = operation.getPaymentFrecuency();
      var letter_quantity = frecuency * period_quantity;
      var initial_payment_date = operation.getInitialPaymentDate();
      var first_payment = initial_payment_date.format("DD/MM/YYYY");
      var last_payment = operation.calculateLastPaymentDate(initial_payment_date, letter_quantity);
      var device_price = operation.calculateDevicePrice();
      var loan_amount = operation.calculateLoanAmount();
      var device_price_without_itbms = operation.calculateDevicePriceWithoutITBMS();
      var itbms = operation.calculateITBMS();
      var letterText = String($(operation.ui.letterPreview).val() || "0.00").replace(/[^\d.]/g, "");

      $(operation.ui.jsDevice).text(
        $(operation.ui.deviceModelId).find("option:selected").text() || "—"
      );
      $(operation.ui.jsFirstPaymentDate).text(first_payment);
      $(operation.ui.jsLastPaymentDate).text(last_payment);
      $(operation.ui.jsLetterQuantity).text(letter_quantity);
      $(operation.ui.jsPaymentType).text(payment_type);
      $(operation.ui.jsDevicePrice).text("$" + Number(device_price_without_itbms).toFixed(2));
      $(operation.ui.jsITBMS).text("$" + Number(itbms).toFixed(2));
      $(operation.ui.jsTotal).text("$" + Number(device_price).toFixed(2));
      $(operation.ui.jsInitialCompost).text(
        "-$" + Math.abs(Number(device_price) - Number(loan_amount)).toFixed(2)
      );
      $(operation.ui.jsLoanAmount).text("$" + Number(loan_amount).toFixed(2));
      $(operation.ui.jsPaymentLetter).text("$" + Number(letterText || 0).toFixed(2) + " USD");
    }

    bindDeviceSubmitGuard() {
      const operation = this;
      const $form = $(operation.ui.form);
      if (!$form.length) return;

      $form
        .off("submit.loanV2Device")
        .on("submit.loanV2Device", function (e) {
          operation.refreshLetterPreview();

          if (!$form.valid()) {
            e.preventDefault();
            $form.find(":input.is-invalid:visible:first").focus();
            return false;
          }
          if (!$("input[name*='[percentage_compost_id]']:checked").length) {
            e.preventDefault();
            alert("Seleccione el porcentaje de abono.");
            return false;
          }
          if (!$("input[name*='[payment_period_id]']:checked").length) {
            e.preventDefault();
            alert("Seleccione el plazo de pago.");
            return false;
          }
          return true;
        });
    }

    bindDeviceSummaryPanels() {
      // Summary lives on GET /v2/loans/:id/summary (after KYC, before Confirmar).
      this.bindDeviceSubmitGuard();
    }

    bindContinue() {
      const operation = this;

      $(operation.ui.continueBtn)
        .off("click.loanV2Continue")
        .on("click.loanV2Continue", function (e) {
          e.preventDefault();

          const $form = $(operation.ui.form);
          if (!$form.length) return;

          if (!$form.valid()) {
            $form.find(":input.is-invalid:visible:first").focus();
            return;
          }

          const $btn = $(this);
          $btn.prop("disabled", true).text(i18n.t("commons.processing") || "Procesando...");

          const formData = new FormData($form[0]);
          const csrf =
            document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "";

          fetch($form.attr("action"), {
            method: "POST",
            headers: {
              "X-CSRF-Token": csrf,
              Accept: "application/json",
              "X-Requested-With": "XMLHttpRequest",
            },
            body: formData,
            credentials: "same-origin",
          })
            .then(async (response) => {
              const data = await response.json().catch(() => ({}));
              if (!response.ok || !data.success) {
                const message =
                  (data.errors && data.errors.join("<br>")) ||
                  "No se pudo enviar a aprobación. Intente de nuevo.";
                throw new Error(message);
              }
              return data;
            })
            .then((data) => {
              operation.openWaitingModal(data);
            })
            .catch((err) => {
              bootbox.alert(err.message || "No se pudo enviar a aprobación.");
              $btn.prop("disabled", false).text("Continuar");
            });
        });
    }

    openWaitingModal(data) {
      const operation = this;
      const $modal = $(operation.ui.waitingModal);
      if (!$modal.length) return;

      operation.bindWaitingModalActions();
      operation.approvalContext = data;
      const loanLabel = data.loan_number ? "#" + data.loan_number : "#—";
      $modal.find(".js-loan-approval-number").text(loanLabel);
      $modal.find(".js-loan-approval-back").attr("href", data.loans_index_url || data.loans_index_url || "/loans");

      if (data.status === "approved" || data.status === "rejected") {
        operation.handleApprovalDecision(data);
        return;
      }

      operation.setApprovalBadge("pending");
      $modal.find(".js-loan-approval-next").prop("disabled", true);
      $modal.removeAttr("hidden").attr("aria-hidden", "false");
      $("body").addClass("loan-approval-modal-open");
      operation.startPolling(data.status_url);
    }

    hideWaitingModal() {
      const $modal = $(this.ui.waitingModal);
      $modal.attr("hidden", true).attr("aria-hidden", "true");
      $("body").removeClass("loan-approval-modal-open");
    }

    handleApprovalDecision(payload) {
      const ctx = Object.assign({}, this.approvalContext || {}, payload || {});
      this.approvalContext = ctx;
      this.setApprovalBadge(ctx.status, ctx.comments || ctx.comments);

      if (ctx.status === "approved") {
        this.stopPolling();
        if (ctx.stage === "kyc") {
          $(this.ui.waitingModal).find(".js-loan-approval-next").prop("disabled", false);
          return;
        }
        this.showIdentityPrequalification(ctx);
        return;
      }

      if (ctx.status === "rejected") {
        this.stopPolling();
        this.hideWaitingModal();
        const indexUrl = ctx.loans_index_url || ctx.loans_index_url || "/loans";
        const msg = this.autoRejectedMessage(ctx);
        bootbox.alert(msg, function () {
          window.location.href = indexUrl;
        });
      }
    }

    autoRejectedMessage(ctx) {
      if (!ctx.auto_rejected) {
        return "La solicitud fue rechazada.";
      }
      if (ctx.rejection_reason === "Política de otorgamiento") {
        return "La solicitud fue rechazada por política de otorgamiento (score).";
      }
      return "La solicitud fue rechazada por política de prevención (país).";
    }

    showIdentityPrequalification(ctx) {
      this.hideWaitingModal();
      const nextUrl = ctx.next_url || ctx.device_url;
      const slug = ctx.consent_slug;
      const message = ctx.prequalification_message;

      if (typeof CreditScore !== "undefined" && message) {
        const score = new CreditScore();
        score.configure();
        score.showPrequalificationAfterApproval(slug, message, nextUrl);
      } else if (nextUrl) {
        window.location.href = nextUrl;
      }
    }

    setApprovalBadge(status, comments) {
      const $badge = $(this.ui.waitingModal).find(".js-loan-approval-badge");
      const $text = $badge.find(".js-loan-approval-badge-text");
      $badge.attr("data-status", status);

      if (status === "approved") {
        $text.text("Aprobado");
      } else if (status === "rejected") {
        $text.text(comments ? "Rechazado: " + comments : "Rechazado");
      } else {
        $text.text("Pendiente de aprobación");
      }
    }

    startPolling(statusUrl) {
      const operation = this;
      operation.stopPolling();
      if (!statusUrl) return;

      const tick = () => {
        fetch(statusUrl, {
          headers: { Accept: "application/json" },
          credentials: "same-origin",
        })
          .then((response) => {
            if (!response.ok) throw new Error("poll_failed");
            return response.json();
          })
          .then((payload) => {
            if (!payload || !payload.status) return;

            operation.setApprovalBadge(payload.status, payload.comments || payload.comments);

            if (payload.status === "approved" || payload.status === "rejected") {
              operation.handleApprovalDecision(payload);
            }
          })
          .catch(() => {
            // Keep polling; transient network errors should not kill the wait UX.
          });
      };

      tick();
      operation.pollTimer = setInterval(tick, operation.pollIntervalMs);
    }

    stopPolling() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    }
  }

  window.LoanV2 = LoanV2;
})();
